// src/firebaseConfig.js
// --- COPY-PASTE THIS ENTIRE FILE ---

// Import the functions you need from the SDKs
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// TODO: Replace this with your own unique config object from Firebase!
const firebaseConfig = {
  apiKey: "AIzaSyC5J7Av3X6y9KuiABpW1dOkKifxYo_AVsE",
  authDomain: "boardvote-9f06b.firebaseapp.com",
  projectId: "boardvote-9f06b",
  storageBucket: "boardvote-9f06b.firebasestorage.app",
  messagingSenderId: "674827317285",
  appId: "1:674827317285:web:5bbabf575dd33b9b170fcc"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize and export (make available) the services we'll use
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// You can also export the main app object if needed
export default app;